import { render, staticRenderFns } from "./CertificationsComponent.vue?vue&type=template&id=446beecc&scoped=true"
import script from "./CertificationsComponent.vue?vue&type=script&lang=js"
export * from "./CertificationsComponent.vue?vue&type=script&lang=js"
import style0 from "./CertificationsComponent.vue?vue&type=style&index=0&id=446beecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446beecc",
  null
  
)

export default component.exports